var App = App || {};

App.Testimonials = (function ($) {
    "use strict";
    var $testimonialSliders;

    function init() {
        $testimonialSliders = $(".testimonials");
        $testimonialSliders.each(function () {
            var $carousel = $(this).find('.testimonials-inner-slides'),
                $controlPrev = $(this).find('.testimonial-prev'),
                $controlNext = $(this).find('.testimonial-next');

            $carousel.slick({
                arrows: false,
                autoplay: false,
                swipe: true,
                dots: false,
                fade: true,
                focusOnSelect: true,
                centerMode: false,
                adaptiveHeight: true,
                slidesToScroll: 1,
                infinite: true,
                slidesToShow: 1
            });

            // Find the buttons and set them to slick next and slick prev

            $controlPrev.on("click", function () {
                $carousel.slick("slickPrev");
            });
            $controlNext.on("click", function () {
                $carousel.slick("slickNext");
            });



        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Testimonials.init();
});